<template>
    <div >
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="reportTitle"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="notesCompositeReport"
          :ReportName="'NotesCompositeReport'"
          :ReportTitle="reportTitle"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'

    export default Vue.extend({
        name: "NotesCompositeReport",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          closeWindow: Function,
          reportTitle: String,
          fileList: Array,
          guid: String
        },
        data() {
            return {
                isReportVisible: false,
                reportParams: [],
            }
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.closeWindow()
            },

            onClickClose() {
              this.closeWindow()
            },

            onClickShowReport() {
              this.reportParams = []

              this.reportParams.push({ paramName: 'title', paramValue: this.reportTitle})
              this.reportParams.push({ paramName: 'guid', paramValue: this.guid})
              this.reportParams.push({ paramName: 'fileList', paramValue: this.fileList})

              this.isReportVisible = true
              this.$refs.notesCompositeReport.buildDocument(this.reportParams)
            }
        },
        
        mounted () {
          this.onClickShowReport()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
